import request from "../../utils/wapRequest";
const url = process.env.VUE_APP_BASE_API_POINT;
const BASE_URL_PAYMENT = process.env.VUE_APP_BASE_API_PAYMENT;
const BASE_URL_STAGING = process.env.VUE_APP_BASE_API_STAGING;

const PointResource = {
  get_history_point_bonus(query) {
    return request({
      url: `${url}/payment_point_bonus/get_history_point_bonus_user_for_wap`,
      method: "GET",
      headers: {
        authen: "fYfXZnz5EDuwHQWNmBha6TcegrV6HbFD0zvdNYkqott0URX7bbpVea83CZ1pb"
      },
      params: query
    });
  },
  getPoint(query) {
    return request({
      url: `${BASE_URL_STAGING}/for_cms/reload_point`,
      method: "GET",
      headers: {
        authen:
          "qdk6jRcxvXzbR7BNJh5J3Q9JTRuDx5M7e7ewGURwurc8def5eV7avU4qBTtTLuRPHpH"
      },
      params: query
    });
  },

  detail_epay_transaction(query) {
    return request({
      url: `${BASE_URL_STAGING}/for_cms/detail_epay_transaction`,
      method: "GET",
      headers: {
        authen:
          "qdk6jRcxvXzbR7BNJh5J3Q9JTRuDx5M7e7ewGURwurc8def5eV7avU4qBTtTLuRPHpH"
      },
      params: query
    });
  },
  get_detail_transaction(query) {
    return request({
      url: `${BASE_URL_STAGING}/for_cms/get_detail_transaction`,
      method: "GET",
      headers: {
        authen:
          "qdk6jRcxvXzbR7BNJh5J3Q9JTRuDx5M7e7ewGURwurc8def5eV7avU4qBTtTLuRPHpH"
      },
      params: query
    });
  }
};
export { PointResource as default };
